import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import 'rc-collapse/assets/index.css';
import QAItem from "../QAItem";



class QAGroup extends Component {


    render() {
        const {QA} = this.props;
        if (QA) {
            const { questions, possibleAnswers, problematicAnswers } = QA;
            return (
                <>
                    {questions && questions.length >= 1 && <QAItem items={questions} label={"Question"} type={"question"}/>}
                    {possibleAnswers && possibleAnswers.length >= 1 && <QAItem items={possibleAnswers} label={"Possible Answers"} type={"possibleAnswer"}/>}
                    {problematicAnswers && problematicAnswers.length >= 1 && <QAItem items={problematicAnswers} label={"Problematic Answers"} type={"problematicAnswer"}/>}
                </>
            );
        } else {
            return (
                null
            )
        }

    }
}


QAGroup.propTypes = {
    QA: PropTypes.object,
};


export default QAGroup;